module.exports = __webpack_public_path__ + "img/partner_divine-bar.d47e0efd.webp";